import { http } from 'globalState/global-state.js';

/**
 * Получение подсказок адресов
 * @param {string} query - поисковый запрос
 * @param {string[]} locationRestrictions - ограничения по локации
 * @returns {Promise} - промис с данными подсказок
 */
export const getAddressHints = (
    params = {},
    locationRestrictions = ['Москва', 'московская'],
    citiesRestrictions = []
) => {
    return http.xmlUnsafeRequest
        .get('/geo/address-hints/', {
            params: {
                locationRestrictions,
                citiesRestrictions,
                ...params,
            },
        })
        .catch((err) => {
            console.error(err);
            throw new Error('Не смогли загрузить подсказки адресов');
        });
};

/**
 * Геокодирование адреса в координаты
 * @param {string} address - адрес для геокодирования
 * @returns {Promise} - промис с координатами
 */
export const geocodeAddress = (address) => {
    return http.xmlUnsafeRequest
        .post('/geo/geocode/address/', {
            address,
        })
        .catch((err) => {
            console.error(err);
            throw new Error('Не смогли загрузить подсказки адресов');
        });
};

/**
 * Обратное геокодирование координат в адрес
 * @param {string} lat - широта
 * @param {string} lng - долгота
 * @returns {Promise} - промис с данными адреса
 */
export const geocodeCoordinates = (lat, lng) => {
    return http.xmlUnsafeRequest
        .post('/geo/geocode/coordinates/', {
            lat,
            lng,
        })
        .catch((err) => {
            console.error(err);
            throw new Error('Не смогли загрузить подсказки адресов');
        });
};
